import React, { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ProtectedRoute = ({ children }) => {
  const [agreed, setAgreed] = useState(
    localStorage.getItem("disclaimerAgreed") === "true"
  );
  const user = useState(localStorage.getItem("user__sadada(*&(*&("));
  const navigate = useNavigate();

  const handleAgree = () => {
    localStorage.setItem("disclaimerAgreed", "true");
    setAgreed(true);
  };

  const handleDecline = () => {
    Swal.fire({
      title: "Beta Access Declined",
      text: "You have declined the beta testing agreement. As a result, access to the platform has been disabled. If you believe this was a mistake or would like to participate in the beta, please contact us at: miraclepaceinc@outlook.com",
      icon: "warning",
      confirmButtonText: "OK",
    }).then(() => {
      window.close();
    });
  };

  if (agreed) {
    if (user[0]) return <Navigate to="/home" replace />;
    return <Navigate to="/signin" replace />;
  }

  return (
    <div className="disclaimer-container">
      <div className="disclaimer-box">
        <h2>Beta Testing Disclaimer</h2>
        <p>
          This website is currently provided as part of a private beta testing
          program and is accessible by invitation only. The platform and its
          features are under active development and are made available on an{" "}
          <em>“as is”</em> and
          <em>“as available”</em> basis, without warranties of any kind, whether
          express or implied.
        </p>
        <p>
          This beta version is intended solely for evaluation and feedback
          purposes and is not to be used for any commercial or profit-generating
          activities. The information presented may be incomplete, inaccurate,
          or subject to change without notice.
        </p>
        <p>
          By accessing or using this website, you acknowledge and agree that:
          <ul className="text-start mt-2">
            <li>
              You are an authorized invitee participating in the beta test;
            </li>
            <li>
              You understand the platform is in a testing phase and may contain
              bugs or errors;
            </li>
            <li>
              The platform operators disclaim any liability for data loss,
              inaccuracies, service interruptions, or other issues arising from
              use during this phase.
            </li>
          </ul>
        </p>
        <p>
          Your continued use constitutes acceptance of these terms. For
          questions or to provide feedback, please contact us at:{" "}
          <a href="mailto:miraclepaceinc@outlook.com">
            miraclepaceinc@outlook.com
          </a>
          .
        </p>
        <div className="disclaimer-buttons mt-4">
          <button className="btn btn-success" onClick={handleAgree}>
            I Agree
          </button>
          <button
            className="btn btn-outline-dark-custom"
            onClick={handleDecline}
          >
            I Don't Agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProtectedRoute;
